export default "__VITE_ASSET__4e7f2cfb__"